import {
  ref,
  readonly,
  onMounted,
  onBeforeUnmount,
  watch,
  computed
} from "vue";
import { eventBus } from "#blokkli/helpers/eventBus";
function getControlState(e) {
  if ("code" in e && e.code === "CapsLock") {
    return true;
  }
  return e.getModifierState("Control") || e.getModifierState("Meta");
}
export default function(animationProvider) {
  const isPressingControl = ref(false);
  const isPressingSpace = ref(false);
  const isPressingShift = ref(false);
  const registeredShortcuts = ref([]);
  const onKeyUp = (e) => {
    isPressingControl.value = e.getModifierState("Control") || e.getModifierState("Meta");
    isPressingShift.value = e.getModifierState("Shift");
    if (e.code === "Space") {
      isPressingSpace.value = false;
    }
    if (e.code === "Control" || e.key === "CapsLock") {
      isPressingControl.value = false;
    }
  };
  const onKeyDown = (e) => {
    isPressingControl.value = getControlState(e);
    isPressingShift.value = e.getModifierState("Shift");
    if (!isPressingSpace.value) {
      eventBus.emit("keyPressed", {
        code: e.key,
        shift: e.shiftKey,
        meta: e.ctrlKey || e.metaKey || isPressingControl.value,
        originalEvent: e
      });
    }
    if (e.code === "Space") {
      isPressingSpace.value = true;
    }
  };
  const onVisibilityChange = () => {
    isPressingControl.value = false;
    isPressingSpace.value = false;
  };
  onMounted(() => {
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("keyup", onKeyUp);
    document.addEventListener("visibilitychange", onVisibilityChange);
  });
  onBeforeUnmount(() => {
    document.removeEventListener("keydown", onKeyDown);
    document.removeEventListener("keyup", onKeyUp);
    document.removeEventListener("visibilitychange", onVisibilityChange);
  });
  watch(isPressingSpace, () => {
    animationProvider.requestDraw();
  });
  watch(isPressingControl, () => {
    animationProvider.requestDraw();
  });
  const getShortcutKey = (shortcut) => [!!shortcut.meta, !!shortcut.shift, shortcut.code].join("-");
  const registerShortcut = (shortcut) => {
    registeredShortcuts.value.push({ key: getShortcutKey(shortcut), shortcut });
  };
  const unregisterShortcut = (shortcut) => {
    const key = getShortcutKey(shortcut);
    registeredShortcuts.value = registeredShortcuts.value.filter(
      (v) => v.key !== key
    );
  };
  const shortcuts = computed(() => registeredShortcuts.value);
  function setShortcutStateFromEvent(e) {
    isPressingControl.value = getControlState(e);
    isPressingShift.value = !!e.shiftKey;
  }
  return {
    isPressingSpace: readonly(isPressingSpace),
    isPressingControl: readonly(isPressingControl),
    isPressingShift: readonly(isPressingShift),
    shortcuts,
    registerShortcut,
    unregisterShortcut,
    setShortcutStateFromEvent
  };
}
